import React, { useState, useEffect } from "react";
import { Container, Button, Row, Col, Modal } from "react-bootstrap";
import { useReportContext } from "../_context/ReportContext";
import { blobToBase64 } from "../_utils/utilFunctions";
import emailjs from "@emailjs/browser";

interface EmailSenderProps {
  pdfBlob: Blob | null;
  isEnabled: boolean;
  onEmailSent?: () => void;
}

const EmailSenderClient: React.FC<EmailSenderProps> = ({ pdfBlob, isEnabled, onEmailSent }) => {
  const { currentViewingReport } = useReportContext();
  const [recipientEmail, setRecipientEmail] = useState('');
  const [adminEmails, setAdminEmails] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  useEffect(() => {
    if (currentViewingReport?.Client) {
      setRecipientEmail(currentViewingReport.Client.Email || '');
      if (currentViewingReport.Client.Admins) {
        const emailList = currentViewingReport.Client.Admins.map(admin => admin.Email);
        setAdminEmails(emailList.join(",")); // Changed to comma only, no space
      }
    }
  }, [currentViewingReport]);

  const sendEmailWithPDF = async () => {
    if (!pdfBlob) return;

    // Validate email addresses
    if (!recipientEmail || !recipientEmail.includes('@')) {
      setModalMessage('Invalid recipient email address. Please check the client email.');
      setShowModal(true);
      return;
    }

    setModalMessage('Sending email...');
    setShowModal(true);

    try {
      const clientName = currentViewingReport.Client.Name;

      // Convert the PDF blob to base64 string
      const base64 = await blobToBase64(pdfBlob);

      const templateParams = {
        to_email: recipientEmail,
        cc_email: adminEmails,
        client_name: clientName,
        attachment: base64,  // Sending the base64 string of your PDF
      };

      // Send email with attachment using send
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID!, // Your service ID
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID!, // Your template ID
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY!   // Your public key
      );

      setModalMessage('Email sent to client successfully!');
      onEmailSent?.(); // Call the callback if provided
    } catch (error) {
      console.error("EmailJS error:", error);
      setModalMessage('Failed to send email. Please try again later.');
    }
  };

  return (
    <Container className="p-0 m-0">
      <Row className="p-0 m-0">
        <Col className="p-0 m-0">
          <button
            onClick={sendEmailWithPDF}
            className="au-submit-btn hover-trigger rp-bottom-nav-btn"
            style={{ background: "#4B5563", color: "white", border: "none", padding: "10px 20px" }}
            disabled={!pdfBlob || !isEnabled}
          >
            Email Report to Clients
          </button>
        </Col>
      </Row>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Report Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default EmailSenderClient;
